<div
  class="widget-item-core"
  [ngClass]="{'clear': isClear}"
>
  <ng-content></ng-content>
</div>
